/**
 * Resolve Customer Portal base URL for SSO redirects (login / logout / 401).
 */
export function getCustomerPortalBaseUrl() {
    const { hostname, port, protocol } = window.location;
    const scheme = protocol === 'https:' || hostname.endsWith('.rg-experience.com')
        ? 'https'
        : 'http';

    if (hostname.includes('-test.')) {
        return `${scheme}://customerhub-test.rg-experience.com`;
    }
    if (hostname.includes('-demo.')) {
        return `${scheme}://customerhub-demo.rg-experience.com`;
    }
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
        const portalPort = port === '82' ? '81' : '8081';
        return `http://${hostname}:${portalPort}`;
    }
    return `${scheme}://customerhub.rg-experience.com`;
}

/**
 * Redirect to Customer Portal with optional returnUrl or path suffix.
 * @param {{ returnUrl?: string, path?: string }} options
 */
export function redirectToCustomerPortal({ returnUrl, path } = {}) {
    const base = getCustomerPortalBaseUrl();
    if (returnUrl) {
        window.location.href = `${base}?returnUrl=${encodeURIComponent(returnUrl)}`;
        return;
    }
    window.location.href = path ? `${base}${path}` : base;
}
